import Helper from "@/services/Helper"

export default class PrepareQuery {
    static handle(q) {
        let query = Helper.clone(q)

        return query
    }
}
